import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=0361129c&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=0361129c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361129c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0361129c')) {
      api.createRecord('0361129c', component.options)
    } else {
      api.reload('0361129c', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=0361129c&scoped=true", function () {
      api.rerender('0361129c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/calssModule/collect.vue"
export default component.exports